import React, { useEffect, useState } from 'react';
import { useDispatch } from "react-redux";
import { finishMounted } from "./../../stores/transition";
import { Form } from "react-bootstrap";
import { AddressComponent, newEmptyAddress } from "./../../components/address/AddressComponent";
import axios from './../../http';
import SnackBar from './../../components/snackbar/Snackbar';

const AddressPage = () => {
  const dispatch = useDispatch();

  const [isMounted, setIsMounted] = useState<boolean>(false);
  const [isProcessing, setIsProcessing] = useState<boolean>(false);
  const [address, setAddress] = useState(newEmptyAddress());
  const [isSuccess, setIsSuccess] = useState<boolean>(false);

  if (isMounted) dispatch(finishMounted());

  useEffect(() => {
    (async () => {
      const res = await axios.get('/api/address');
      const attributes = res.data?.data?.attributes;
      setAddress(old => ({
        ...old,
        country: {
          code: attributes?.country?.code || old.country.code,
          name: attributes?.country?.name || old.country.name,
        },
        zip: attributes?.zip || old.zip,
        prefecture: attributes?.prefecture || old.prefecture,
        city: attributes?.city || old.city,
        address: attributes?.address || old.address,
        building_name: attributes?.building_name || old.building_name,
      }));
      setIsMounted(true);
    })();
  }, []);

  const handleOnSubmit = async (e: React.FormEvent<HTMLFormElement>): Promise<void> => {
    try {
      e.preventDefault();
      if (isProcessing) return;
      setIsProcessing(true);

      const values = {
        country: address.country.code,
        zip: address.zip,
        prefecture: address.prefecture,
        city: address.city,
        address: address.address,
        building_name: address.building_name
      }
      await axios.put('/api/address', values);
      setIsSuccess(true);
    } catch(err) {
      console.error(err);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <Form onSubmit={handleOnSubmit}>
      <AddressComponent onAddressChange={setAddress} address={address} />

      <button type="submit" className="w-100" disabled={isProcessing} >
          {isProcessing ? 'Processing...' : '更新'}
      </button>

      <SnackBar onClose={() => setIsSuccess(false)} show={isSuccess}>
        <>保存しました。</>
      </SnackBar>
    </Form>
  );
};

export default AddressPage;
